/**
 * @desc 爬虫http接口
 */
const URL = "/rantion-crawler";
import http, { updateResponse } from "@/http";
export function request(body: defs.crawler.CrawlerRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/crawler/start`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
